export default "__VITE_ASSET__BIRyfmtk__"